import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import Icon from 'screens/shared/icon';
import { _t, getKey } from 'utils';
import { inject } from 'utils/config';
import { ROUTE } from 'constant';

export default ({ history }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChangeLanguageClick = () => {
    const { pathname = '', search = '' } = window.location;
    const returnURL = (pathname + search).replace(process.env.PUBLIC_URL, '');
    history.push(`/language#returnURL=${returnURL}`);
    handleClose();
  };

  const onChangeContractClick = () => {
    history.push('/contracts');
    handleClose();
  };

  const onLogoutClick = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    inject().then(() => {
      history.push(ROUTE.NON_SECURE.LOGIN.path);
    });
  };

  return (
    <div>
      <IconButton
        aria-controls="menu-appbar"
        onClick={handleMenu}
        color="inherit"
        size="large"
      >
        <Icon name="account_circle" type="material" />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {!!getKey('isReseller') && <MenuItem onClick={onChangeContractClick}>{_t('Change Contract')}</MenuItem>}
        <MenuItem onClick={onChangeLanguageClick}>{_t('Change Language')}</MenuItem>
        <MenuItem onClick={onLogoutClick}>{_t('Logout')}</MenuItem>
      </Menu>
    </div>
  );
};
